export const WELCOME_LABEL = 'Welcome to SAM';
export const RESET_LABEL = 'Please indicate your Email from Reset Password Instructions';
export const REMEMBER_LABEL = 'Remember me';
export const LOGIN_LABEL = 'Log in';
export const RESET_PASSWORD = 'Reset Password';
export const EMAIL_LABEL = 'Enter your Email';
export const EMAIL_REQUIRED_MESSAGE = 'Your email is required!';
export const FORGOT_PASSWORD_LABEL = 'Forgot your password?';
export const ERROR_EMAIL_RECOVERY_LABEL = 'Email is not find, Please Contact to IT Support for Instructions...';
export const ERROR_LOGIN_LABEL = 'Log in error.';
export const USER_REQUIRED_MESSAGE = 'Username is required!';
export const USER_MAX_LENGTH_MESSAGE = 'Max length is twenty characters!';
export const USER_PLACEHOLDER =  'Enter your username';
export const PASSWORD_PLACEHOLDER =  'Enter your password';
export const PASSWORD_REQUIRED_MESSAGE = 'Your password is required!';
